<div class="row mt-2">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header bg-white text-center">
        @if (app.permission.businessConfig.seeWarehouseGroupSection) {
          <ul
            class="nav nav-tabs card-header-tabs"
            >
            <li class="nav-item">
              <a
                class="nav-link pointer-link"
                role="button"
                [ngClass]="{ active: viewType === 'warehouse-group' }"
                (click)="viewType = 'warehouse-group'"
                ><i class="fa-regular fa-warehouse"></i>&nbsp;
                {{ app.text.businessConfig.warehouseGroup }}</a
                >
              </li>
              @if (
                app.permission.businessConfig.seeProcessesSection ||
                app.users.currentUser.businessManager
                ) {
                <li
                  class="nav-item"
                  >
                  <a
                    class="nav-link pointer-link"
                    role="button"
                    [ngClass]="{ active: viewType === 'processes' }"
                    (click)="viewType = 'processes'"
                    ><i class="fa-regular fa-gear"></i>&nbsp;
                    {{ app.text.businessConfig.processes }}</a
                    >
                  </li>
                }
              </ul>
            }
          </div>
          <div class="card-body">
            <div class="row">
              <div>
                <!-- Warehouse Groups -->
                @if (app.permission.businessConfig.seeWarehouseGroupSection) {
                  <div
                    >
                    @switch (viewType) {
                      @case ('warehouse-group') {
                        <div>
                          <small class="text-muted"
                            ><i class="fa fa-info-circle"></i>&nbsp;
                            <span
                    [innerHtml]="
                      app.text.businessConfig.warehouseGroupDescription
                    "
                            ></span>
                          </small>
                          <app-warehouse-group> </app-warehouse-group>
                        </div>
                      }
                    }
                  </div>
                }
                <!-- Processes -->
                @if (
                  app.permission.businessConfig.seeProcessesSection ||
                  app.users.currentUser.businessManager
                  ) {
                  <div
                    >
                    @switch (viewType) {
                      @case ('processes') {
                        <div>
                          <div class="mb-3">
                            <small class="text-muted"
                              ><i class="fa fa-info-circle"></i>&nbsp;
                              <span
                                [innerHtml]="app.text.businessConfig.processesDescription"
                                ></span
                              ></small>
                            </div>
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm float-right"
                              (click)="app.businessConfig.runWarehousePartsUpdate()"
                              >
                              <i class="fa fa-play-circle"></i>&nbsp;
                              {{ app.text.operations.run }}
                              {{ app.text.businessConfig.warehousePartsUpdate }}
                            </button>
                            <div>
                              <app-paginator
                                [length]="app.businessConfig.history.length"
                                [index]="app.paginator.focus"
                                (focus)="app.paginator.focus = $event"
                              ></app-paginator>
                              <div class="tableFixHead">
                                <table class="table table-striped spacing-table">
                                  <thead>
                                    <tr>
                                      @for (column of getProcessesColumns(); track column) {
                                        <th
                                          class="table-header"
                                          >
                                          <span class="pointer">{{
                                            app.field.getLabel("operations." + column)
                                          }}</span>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (
                                      item of app.paginator.getPage(
                                      app.businessConfig.history
                                      )
                                      ; track
                                      item) {
                                      <tr
                                        >
                                        @for (column of getProcessesColumns(); track column) {
                                          <td
                                            class="p-1"
                                            >
                                            @if (
                                              column === 'create_time' ||
                                              column === 'complete_time'
                                              ) {
                                              <span
                                                >
                                                {{ item[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                                              </span>
                                            }
                                            @if (column === 'work_type') {
                                              <span>
                                                {{ app.businessConfig.getTypeText(item[column]) }}
                                              </span>
                                            }
                                            @if (column === 'work_log') {
                                              <span>
                                                <button
                                                  type="button"
                                                  class="btn btn-link p-0"
                                                  (click)="downloadLog(item)"
                                                  >
                                                  <i class="fa fa-file-download"></i>
                                                </button>
                                              </span>
                                            }
                                            @if (!app.operations.isSpecialColumn(column)) {
                                              <span
                                                >
                                                {{ item[column] }}
                                              </span>
                                            }
                                          </td>
                                        }
                                      </tr>
                                    }
                                    @if (app.businessConfig.history.length === 0) {
                                      <tr>
                                        <td colspan="99" class="p-1 text-center">
                                          {{ app.text.businessConfig.noHistoryAvailable }}
                                        </td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
